module.exports = __webpack_public_path__ + "img/1185x407px.976b3ec9.png";